"use client";

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Users, Briefcase, Heart, ChefHat } from "lucide-react";
export default function Leistungen() {
  const {
    ref: card1Ref,
    isVisible: card1Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: card2Ref,
    isVisible: card2Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: card3Ref,
    isVisible: card3Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: card4Ref,
    isVisible: card4Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const services = [{
    ref: card1Ref,
    isVisible: card1Visible,
    icon: Users,
    title: "Private Events",
    description: "Authentische neapolitanische Pizza für unvergessliche private Feiern. Frische Zutaten, handgefertigter Teig und das perfekte Leoparding für Ihre Gäste.",
    link: "/PrivateProfessionalWeddingsNeapolitanPizzaWorkshopPage"
  }, {
    ref: card2Ref,
    isVisible: card2Visible,
    icon: Briefcase,
    title: "Berufliche Events",
    description: "Beeindrucken Sie Ihre Geschäftspartner mit Premium-Catering. Professioneller Service und erstklassige Pizza für Ihre einzigartige Firmenveranstaltungen.",
    link: "/ProfessionalEventsPage"
  }, {
    ref: card3Ref,
    isVisible: card3Visible,
    icon: Heart,
    title: "Hochzeiten",
    description: "Machen Sie Ihren besonderen Tag unvergesslich mit authentischer italienischer Küche. Individuell angepasste Menüs für Ihre Traumhochzeit.",
    link: "/WeddingPage"
  }, {
    ref: card4Ref,
    isVisible: card4Visible,
    icon: ChefHat,
    title: "Neapolitanische Pizza Workshop",
    description: "Lernen Sie die Kunst der authentischen neapolitanischen Pizza. Von der Teigzubereitung bis zum perfekten Leoparding, ein unvergessliches Erlebnis für alle Pizza-Liebhaber.",
    link: "/NeapolitanPizzaWorkshopPage"
  }];
  return;
}